/* =========================================================================
   Universal PDP
   Variants · Add-on · Gallery · AJAX cart · works alongside the Seal widget
   ========================================================================= */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    var fmt = String(format || '{{amount}}').replace(/<[^>]*>/g, '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    var m = fmt.match(re), key = m ? m[1] : 'amount', v;
    switch (key) {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return fmt.replace(re, v);
  }

  function json(root, sel, fallback) {
    var el = root.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function PDP(root) {
    if (root.__upd) return;
    root.__upd = this;
    this.root = root;
    this.product = json(root, '[data-upd-product]', null);
    this.inv = json(root, '[data-upd-inventory]', {});
    // Variant rules (from 'Variant rule' blocks): disable / hide / label
    this.rules = json(root, '[data-upd-rules]', {});
    var rules = this.rules;
    (this.product && this.product.variants || []).forEach(function (v) {
      var r = rules[String(v.id)];
      if (!r) return;
      v._rule = r;
      if (r.a === 'disable' || r.a === 'hide') { v._blocked = true; v.available = false; }
    });
    this.cfg = json(root, '[data-upd-config]', {});
    if (!this.product) return;

    this.form = root.querySelector('.upd-form');
    this.el = {
      id: root.querySelector('[data-upd-id]'),
      qty: root.querySelector('[data-qty]'),
      atc: root.querySelector('[data-atc]'),
      atcLabel: root.querySelector('[data-atc-label]'),
      stock: root.querySelector('[data-stock]'),
      msg: root.querySelector('[data-msg]'),
      otPrice: root.querySelector('[data-ot-price]'),
      otCompare: root.querySelector('[data-ot-compare]'),
      addon: root.querySelector('[data-addon]'),
      addonToggle: root.querySelector('[data-addon-toggle]'),
      addonPrice: root.querySelector('[data-addon-price]')
    };

    var firstAddon = root.querySelector('[data-addon-choice]:checked') || root.querySelector('[data-addon-choice]:not(:disabled)');
    this.state = {
      options: this.readOptions(),
      qty: 1,
      addonOn: !!(this.el.addon && this.el.addon.classList.contains('is-on')),
      addonId: firstAddon ? firstAddon.value : null,
      addonPrice: firstAddon ? Number(firstAddon.getAttribute('data-price')) : 0
    };

    this.bindOptions();
    this.bindTap();
    this.pickAvailable();
    this.bindSeal();
    this.bindSealStyle();
    this.bindAddon();
    this.bindQty();
    this.bindForm();
    this.bindGallery();
    // Start on the selected variant's image (URL ?variant= or the auto-picked available one)
    var v0 = this.findVariant(this.state.options);
    if (v0 && v0.featured_media) this.goToMedia(v0.featured_media.id, true);
    this.bindAccordion();
    this.bindPromo();
    this.bindReviews();
    this.update(false);
    if (this._sealBoxes) this.restyleSeal();
  }

  /* ---------------- Variant resolution ---------------- */
  PDP.prototype.readOptions = function () {
    var p = this.product, root = this.root;
    var cur = p.variants.filter(function (v) { return String(v.id) === (root.querySelector('[data-upd-id]') || {}).value; })[0] || p.variants[0];
    return (p.options || []).map(function (_, i) {
      var c = root.querySelector('[data-opt="' + i + '"]:checked');
      return c ? c.value : (cur.options[i] || null);
    });
  };

  /* If the page opens on a sold-out / blocked variant, move to the first buyable one */
  PDP.prototype.pickAvailable = function () {
    if (!this.cfg.autoAvailable) return;
    var cur = this.findVariant(this.state.options);
    if (cur && cur.available) return;
    var root = this.root, self = this;
    var target = this.product.variants.filter(function (v) {
      if (!v.available) return false;
      // every option value of it must be on the page
      return v.options.every(function (val, i) {
        return Array.prototype.some.call(root.querySelectorAll('[data-opt="' + i + '"]'), function (inp) { return inp.value === val; });
      });
    })[0];
    if (!target) return;
    this.state.options = target.options.slice();
    target.options.forEach(function (val, i) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-opt="' + i + '"]'), function (inp) { inp.checked = inp.value === val; });
    });
    if (self.el.id) self.el.id.value = target.id;
  };

  PDP.prototype.findVariant = function (opts) {
    return this.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0] || null;
  };

  /* Seal writes the chosen plan into an input/select named "selling_plan".
     Empty value = one-time purchase. */
  PDP.prototype.sealPlanId = function () {
    var f = this.form;
    if (!f) return '';
    var el = f.querySelector('[name="selling_plan"]:checked') ||
             f.querySelector('input[type="hidden"][name="selling_plan"], select[name="selling_plan"]');
    if (!el && f.id) {
      el = document.querySelector('[form="' + f.id + '"][name="selling_plan"]:checked') ||
           document.querySelector('[form="' + f.id + '"][name="selling_plan"]');
    }
    if (!el) {
      el = this.root.querySelector('[name="selling_plan"]:checked') ||
           this.root.querySelector('input[type="hidden"][name="selling_plan"], select[name="selling_plan"]');
    }
    return el && el.value ? String(el.value) : '';
  };

  PDP.prototype.allocation = function (v) {
    var id = this.sealPlanId();
    if (!v || !id || !v.selling_plan_allocations) return null;
    return v.selling_plan_allocations.filter(function (a) { return String(a.selling_plan_id) === id; })[0] || null;
  };

  PDP.prototype.money = function (c) { return formatMoney(c, this.cfg.moneyFormat); };

  /* ---------------- iOS single-tap fix ----------------
     iOS Safari sometimes treats the first tap on a <label> as a "hover" and
     only selects on the second tap. On touch devices we select on touchend
     ourselves (packs, glass cards and Seal purchase options). */
  PDP.prototype.bindTap = function () {
    var root = this.root;
    if (!('ontouchstart' in window) && !(navigator.maxTouchPoints > 0)) return;
    var sx = 0, sy = 0, moved = false;
    root.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0];
      if (t) { sx = t.clientX; sy = t.clientY; }
      moved = false;
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      var t = e.touches && e.touches[0];
      if (t && (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10)) moved = true;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (moved) return;
      var target = e.target;
      if (!target || !target.closest) return;
      if (target.closest('select, a, button, textarea, input[type="text"], input[type="number"]')) return;
      var card = target.closest('.upd-pack, .upd-chip, .upd-addcard, .upd-sealopt');
      if (!card || !root.contains(card)) return;
      var input = card.querySelector('input[type="radio"]');
      if (!input || input.disabled || input.checked) return;
      e.preventDefault();   // cancel iOS's delayed / hover click
      input.click();        // checks it + fires click/input/change (our code and Seal both hear it)
    }, { passive: false });
  };

  /* ---------------- Bindings ---------------- */
  PDP.prototype.bindOptions = function () {
    var self = this;
    this.root.querySelectorAll('[data-opt]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.state.options[Number(input.getAttribute('data-opt'))] = input.value;
        self.update(true);
      });
    });
  };

  /* Recalculate the button total whenever Seal's widget changes */
  /* ---------------- Seal widget restyle ----------------
     Seal's markup/classes can change between versions, so we tag its DOM by
     STRUCTURE (radios, prices, badge text) with our own upd-seal* classes and
     style those. Runs again whenever Seal re-renders. */
  PDP.prototype.bindSealStyle = function () {
    var self = this;
    if (!this.cfg.sealStyle || !window.MutationObserver) return;
    var boxes = Array.prototype.slice.call(this.root.querySelectorAll('.upd-seal, .upd-app'));
    this._sealBoxes = boxes;
    boxes.forEach(function (box) {
      box.classList.add('upd-sealbox');
      if (self.cfg.sealHideTitle) box.classList.add('upd-sealbox--notitle');
      if (self.cfg.sealHideDetails) box.classList.add('upd-sealbox--nodetails');
      var t;
      var run = function () { try { self.styleSeal(box); } catch (e) {} };
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 40); })
        .observe(box, { childList: true, subtree: true, characterData: true });
      box.addEventListener('change', function () { setTimeout(run, 0); });
      box.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.upd-sealextra__btn');
        if (btn) {
          e.preventDefault(); e.stopPropagation();
          var wrap = btn.closest('.upd-sealextra');
          var open = !wrap.classList.contains('is-open');
          wrap.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          return;
        }
        setTimeout(run, 30);
      }, true);
      run();
      [300, 900, 1800, 3500, 6000, 10000].forEach(function (ms) { setTimeout(run, ms); });
      window.addEventListener('load', run);
    });
  };

  PDP.prototype.restyleSeal = function () {
    var self = this;
    (this._sealBoxes || []).forEach(function (b) { try { self.styleSeal(b); } catch (e) {} });
  };

  function leaves(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('*')).filter(function (n) {
      return !n.children.length && n.textContent.trim() && !/^(SCRIPT|STYLE|OPTION)$/.test(n.tagName);
    });
  }
  function isPrice(txt) {
    txt = txt.trim();
    return txt.length <= 22 && /\d/.test(txt) && !/%/.test(txt) && !/[a-z]{3,}/i.test(txt);
  }

  /* Which selling plans does a Seal option belong to?
     1) ids found in the option (radio value, inputs, select options)
     2) option label text matching a selling plan group / plan name        */
  PDP.prototype.sealOptionPlans = function (el, labelText) {
    var groups = this.product.selling_plan_groups || [];
    var ids = [];
    Array.prototype.slice.call(el.querySelectorAll('input,option')).forEach(function (n) {
      if (n.value) ids.push(String(n.value));
    });
    Array.prototype.slice.call(el.querySelectorAll('[data-selling-plan-id],[data-selling-plan-group-id],[data-id]')).forEach(function (n) {
      ['data-selling-plan-id', 'data-selling-plan-group-id', 'data-id'].forEach(function (a) { if (n.getAttribute(a)) ids.push(n.getAttribute(a)); });
    });
    var planIds = [];
    groups.forEach(function (g) {
      var gHit = ids.indexOf(String(g.id)) > -1;
      g.selling_plans.forEach(function (p) {
        if (gHit || ids.indexOf(String(p.id)) > -1) planIds.push(String(p.id));
      });
    });
    if (planIds.length) return planIds;

    var norm = function (t) { return String(t || '').toLowerCase().replace(/[^a-z0-9%]+/g, ' ').trim(); };
    var lt = norm(labelText);
    if (!lt) return null;
    groups.forEach(function (g) {
      var gn = norm(g.name);
      var gHit = gn && (lt.indexOf(gn) > -1 || gn.indexOf(lt) > -1);
      g.selling_plans.forEach(function (p) {
        var pn = norm(p.name);
        if (gHit || (pn && (lt.indexOf(pn) > -1 || pn.indexOf(lt) > -1))) planIds.push(String(p.id));
      });
    });
    return planIds.length ? planIds : null;
  };

  /* Extra information under a Seal subscribe option.
     Content comes from 'Subscription info' blocks (<template data-seal-extra>). */
  PDP.prototype.sealExtras = function () {
    if (!this._extras) {
      this._extras = Array.prototype.slice.call(this.root.querySelectorAll('template[data-seal-extra]')).map(function (t, i) {
        return {
          key: 'x' + i,
          match: (t.getAttribute('data-match') || '').toLowerCase().trim(),
          mode: t.getAttribute('data-mode') || 'selected',
          title: t.getAttribute('data-title') || 'More details',
          html: t.innerHTML
        };
      });
    }
    return this._extras;
  };

  PDP.prototype.injectSealExtra = function (el, label) {
    var list = this.sealExtras();
    var cur = el.querySelector('.upd-sealextra');
    if (!list.length) { if (cur) cur.parentNode.removeChild(cur); return; }
    var txt = (label ? label.textContent : el.textContent).replace(/\u00a0/g, ' ').toLowerCase();
    var ex = list.filter(function (x) {
      if (!x.match) return true;
      return x.match.split(',').some(function (m) { m = m.trim(); return m && txt.indexOf(m) > -1; });
    })[0];
    if (!ex) { if (cur) cur.parentNode.removeChild(cur); return; }
    if (cur && cur.getAttribute('data-key') === ex.key) return;
    if (cur) cur.parentNode.removeChild(cur);
    var node = document.createElement('div');
    node.className = 'upd-sealextra upd-sealextra--' + ex.mode;
    node.setAttribute('data-key', ex.key);
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
    var inner = '<div class="upd-sealextra__in"><div class="upd-sealextra__pad upd-rte">' + ex.html + '</div></div>';
    node.innerHTML = ex.mode === 'toggle'
      ? '<button type="button" class="upd-sealextra__btn" aria-expanded="false"><span>' + esc(ex.title) + '</span><span class="upd-plus" aria-hidden="true"></span></button>' + inner
      : inner;
    el.appendChild(node);
  };

  PDP.prototype.styleSeal = function (box) {
    var self = this, v = this.state.variant;
    var all = Array.prototype.slice.call(box.querySelectorAll('input[type="radio"]'));
    if (!all.length) return;
    var group = all[0].name;
    var radios = all.filter(function (r) { return r.name === group; });

    var opts = radios.map(function (r) {
      var el = r.parentElement;
      while (el.parentElement && el.parentElement !== box &&
             el.parentElement.querySelectorAll('input[type="radio"][name="' + group + '"]').length === 1) {
        el = el.parentElement;
      }
      return { r: r, el: el };
    });
    if (opts[0].el.parentElement && opts[0].el.parentElement !== box) opts[0].el.parentElement.classList.add('upd-sealopts');

    var allocIds = (v && v.selling_plan_allocations || []).map(function (a) { return String(a.selling_plan_id); });
    var firstVisible = null, checkedHidden = false;

    opts.forEach(function (o) {
      var el = o.el, r = o.r;
      var oneTime = /one[\s-]*time/i.test(el.textContent);
      var refEl = r;
      if (!r.getBoundingClientRect().height) refEl = r.nextElementSibling || r.parentElement || r;
      var rTop = refEl.getBoundingClientRect().top;
      var rowOf = function (n) { return Math.abs(n.getBoundingClientRect().top - rTop) < 26; };

      el.classList.add('upd-sealopt');
      el.classList.toggle('upd-sealopt--sub', !oneTime);
      el.classList.toggle('upd-sealopt--one', oneTime);
      el.classList.toggle('is-active', r.checked);

      var lv = leaves(el).filter(function (n) { return !n.classList.contains('upd-sealinjected') && !n.classList.contains('upd-sealbadge--own') && !n.closest('.upd-sealextra'); });

      // badge first, so it is never mistaken for the option label
      var isBadgeText = function (t) { return t.length <= 16 && /^(save|sale|off|\d+\s*%\s*off)\b/i.test(t) && !/subscribe/i.test(t); };
      var badge = el.querySelector('.upd-sealbadge-src');
      if (!badge && !oneTime) {
        badge = lv.filter(function (n) { return isBadgeText(n.textContent.replace(/\u00a0/g, ' ').trim()); })[0] || null;
      }

      var label = null, rowPrices = [];
      lv.forEach(function (n) {
        if (n === badge) return;
        var txt = n.textContent.replace(/\u00a0/g, ' ').trim();
        n.classList.remove('upd-sealprice', 'upd-sealcompare', 'upd-seallabel');
        if (!rowOf(n)) return;
        if (isPrice(txt)) {
          var cmp = !!n.closest('s,del,strike') || getComputedStyle(n).textDecorationLine.indexOf('line-through') > -1;
          n.classList.add(cmp ? 'upd-sealcompare' : 'upd-sealprice');
          rowPrices.push(n);
        } else if (!label && txt.length < 60 && !isBadgeText(txt) && /subscribe|one[\s-]*time|purchase|deliver|\d\s*%/i.test(txt)) {
          label = n;
        }
      });
      if (!label) {
        label = lv.filter(function (n) {
          var t = n.textContent.replace(/\u00a0/g, ' ').trim();
          return n !== badge && t.length < 60 && !isBadgeText(t) && /subscribe|one[\s-]*time/i.test(t);
        })[0] || null;
      }
      if (label) label.classList.add('upd-seallabel');

      // ---- show only the plans that exist for the selected variant ----
      var visible = true;
      if (!oneTime && v) {
        var plans = self.sealOptionPlans(el, label ? label.textContent : '');
        if (plans) {
          visible = plans.some(function (id) { return allocIds.indexOf(id) > -1; });
        } else {
          // fallback: a subscribe option with no discount vs one-time price is not for this variant
          var sp = el.querySelector('.upd-sealprice');
          var hasDiscountPlan = (v.selling_plan_allocations || []).some(function (a) { return a.price < v.price; });
          if (sp && hasDiscountPlan && sp.textContent.replace(/\s/g, '') === self.money(v.price).replace(/\s/g, '')) visible = false;
        }
      }
      el.classList.toggle('upd-sealopt--hidden', !visible);
      if (!visible && r.checked) checkedHidden = true;
      if (visible && !oneTime && !firstVisible) firstVisible = r;
      if (visible && oneTime && !firstVisible) firstVisible = r;

      // ---- badge top-right ----
      // Seal's own badge ("Save ") is hidden; we render our own badge so the
      // text is correct on first load and Seal can't overwrite it.
      if (!oneTime) {
        try {
          if (badge) {
            badge.classList.add('upd-sealbadge-src', 'upd-sealfake');
            var bp = badge.parentElement;
            if (bp && bp !== el && bp.textContent.trim() === badge.textContent.trim()) bp.classList.add('upd-sealfake');
          }
          var own = null;
          for (var k = 0; k < el.children.length; k++) {
            if (el.children[k].classList.contains('upd-sealbadge--own')) { own = el.children[k]; break; }
          }
          var tpl = self.cfg.sealBadge || '';
          var out = null;
          if (tpl && tpl.indexOf('[percent]') === -1) out = tpl;
          else if (tpl) {
            // read % from the option's visible text: "Subscribe & Save 15%"
            var optText = '';
            var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), tn;
            while ((tn = walker.nextNode())) {
              var par = tn.parentElement;
              if (!par || par.closest('.upd-sealbadge--own, .upd-sealextra, .upd-sealbadge-src')) continue;
              optText += ' ' + tn.nodeValue;
            }
            optText = optText.replace(/\u00a0/g, ' ');
            var mm = optText.match(/(?:save|subscribe)[^%\d]{0,25}(\d+(?:\.\d+)?)\s*%/i) || optText.match(/(\d+(?:\.\d+)?)\s*%\s*off/i);
            var pct = mm ? mm[1] : null;
            if (pct == null) {
              var ids = self.sealOptionPlans(el, label ? label.textContent : '') || [];
              (self.product.selling_plan_groups || []).forEach(function (g) {
                g.selling_plans.forEach(function (p) {
                  var adj = p.price_adjustments && p.price_adjustments[0];
                  if (pct == null && ids.indexOf(String(p.id)) > -1 && adj && adj.value_type === 'percentage') pct = adj.value;
                });
              });
            }
            if (pct != null) out = tpl.replace('[percent]', pct);
          }
          if (!out && badge) out = badge.textContent.replace(/\u00a0/g, ' ').trim();
          if (out) {
            if (!own) {
              own = document.createElement('span');
              own.className = 'upd-sealbadge upd-sealbadge--own';
              el.appendChild(own);
            }
            if (own.textContent !== out) own.textContent = out;
          } else if (own) {
            own.parentNode.removeChild(own);
          }
        } catch (err) {}
      }

      // ---- extra information (Subscription info blocks) ----
      if (!oneTime) self.injectSealExtra(el, label);

      // ---- one-time: compare-at price like the design ----
      if (oneTime) {
        var inj = el.querySelector('.upd-sealinjected');
        var main = el.querySelector('.upd-sealprice');
        // Seal's own crossed-out price (any <s>/<del>/<strike> or line-through text), not ours
        var native = null;
        Array.prototype.some.call(el.querySelectorAll('*'), function (n) {
          if (n.classList.contains('upd-sealinjected') || n.closest('.upd-sealinjected')) return false;
          if (!n.textContent.trim() || n.children.length) return false;
          var struck = !!n.closest('s,del,strike') ||
                       getComputedStyle(n).textDecorationLine.indexOf('line-through') > -1 ||
                       (n.parentElement && getComputedStyle(n.parentElement).textDecorationLine.indexOf('line-through') > -1);
          if (struck && /\d/.test(n.textContent)) { native = n; return true; }
          return false;
        });
        if (main && v && v.compare_at_price > v.price && !native) {
          var txtc = self.money(v.compare_at_price);
          if (!inj) {
            inj = document.createElement('s');
            inj.className = 'upd-sealcompare upd-sealinjected';
            main.parentNode.insertBefore(inj, main);
          }
          if (inj.textContent !== txtc) inj.textContent = txtc;
        } else if (inj) {
          inj.parentNode.removeChild(inj);
        }
      }
    });

    // if Seal still has a hidden plan selected, move to the first valid option
    if (checkedHidden && firstVisible && !firstVisible.checked) {
      firstVisible.click();
    }

    leaves(box).forEach(function (n) {
      if (n.closest('.upd-sealopt')) return;
      var t = n.textContent.trim();
      if (/purchase options/i.test(t)) n.classList.add('upd-sealtitle');
      if (/details/i.test(t)) (n.closest('a,button') || n.parentElement || n).classList.add('upd-sealdetails');
    });
  };

  PDP.prototype.bindSeal = function () {
    var self = this, f = this.form;
    if (!f) return;
    var t;
    self._lastPlan = self.sealPlanId();
    // Only re-render when Seal's selected plan actually changes (avoids loops)
    function check() {
      clearTimeout(t);
      t = setTimeout(function () {
        var p = self.sealPlanId();
        if (p !== self._lastPlan) { self._lastPlan = p; self.update(false); }
      }, 60);
    }
    f.addEventListener('change', check);
    f.addEventListener('click', check);
    if (window.MutationObserver) {
      new MutationObserver(check).observe(f, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'checked'] });
    }
  };

  PDP.prototype.bindAddon = function () {
    var self = this, t = this.el.addonToggle;
    if (!t) return;
    t.addEventListener('click', function () {
      self.state.addonOn = !self.state.addonOn;
      self.update(false);
    });
    this.root.querySelectorAll('[data-addon-choice]').forEach(function (r) {
      r.addEventListener('change', function () {
        self.state.addonId = r.value;
        self.state.addonPrice = Number(r.getAttribute('data-price')) || 0;
        var img = self.root.querySelector('[data-addon-img]');
        if (img && r.getAttribute('data-img')) img.src = r.getAttribute('data-img');
        self.update(false);
      });
    });
  };

  PDP.prototype.bindQty = function () {
    var self = this, q = this.el.qty;
    if (!q) return;
    function set(n) { n = Math.max(1, parseInt(n, 10) || 1); q.value = n; self.state.qty = n; self.update(false); }
    this.root.querySelector('[data-qty-minus]').addEventListener('click', function () { set(self.state.qty - 1); });
    this.root.querySelector('[data-qty-plus]').addEventListener('click', function () { set(self.state.qty + 1); });
    q.addEventListener('change', function () { set(q.value); });
  };

  /* The Add to Cart button is type="button" and handled only here.
     Apps like Rebuy Smart Cart and some themes also listen for product-form
     submits and add the item themselves — that caused the double quantity.
     Any real submit (e.g. Enter in the qty box) is stopped and routed here. */
  PDP.prototype.bindForm = function () {
    var self = this;
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        if (self._nativeSubmit) return;           // our own deliberate submit
        e.preventDefault();
        e.stopImmediatePropagation();
        self.add();
      }, true);
    }
    if (this.el.atc) {
      this.el.atc.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.add();
      });
    }
  };


  /* ---------------- Render ---------------- */
  PDP.prototype.update = function (variantChanged) {
    var s = this.state, el = this.el, cfg = this.cfg, self = this;
    var v = this.findVariant(s.options);
    s.variant = v;

    // availability of option values (combined with the other selected options)
    this.root.querySelectorAll('[data-opt]').forEach(function (input) {
      var i = Number(input.getAttribute('data-opt'));
      var test = s.options.slice(); test[i] = input.value;
      var tv = self.findVariant(test);
      var ok = !!(tv && tv.available);
      var label = input.closest('label');
      if (label) {
        var rule = tv && tv._rule;
        var keepVisible = rule && (rule.a === 'disable' || rule.a === 'label');
        label.classList.toggle('is-soldout', !ok);
        label.classList.toggle('is-blocked', !!(tv && tv._blocked));
        label.hidden = (!ok && cfg.soldout === 'hide' && !input.checked && !keepVisible) ||
                       (rule && rule.a === 'hide' && !input.checked);
        var be = label.querySelector('[data-opt-badge]');
        if (be) {
          var bt = '';
          if (rule && rule.b) bt = rule.b;
          else if (tv && tv._blocked) bt = cfg.soldoutBadge || '';
          else if (!ok) bt = cfg.soldoutBadge || '';
          else if (be.getAttribute('data-rule-badge') && rule) bt = be.getAttribute('data-rule-badge');
          be.textContent = bt;
          be.hidden = !bt;
        }
      }
      if (tv) {
        var price = label && label.querySelector('[data-pack-price]');
        if (price) price.textContent = self.money(tv.price);
      }
    });

    var alloc = this.allocation(v);

    if (v) {
      // one-time prices
      if (el.otPrice) el.otPrice.textContent = this.money(v.price);
      if (el.otCompare) {
        el.otCompare.hidden = !(v.compare_at_price > v.price);
        if (v.compare_at_price) el.otCompare.textContent = this.money(v.compare_at_price);
      }
    }

    // hidden variant field — Seal listens to this to refresh its widget
    if (el.id && v && el.id.value !== String(v.id)) {
      el.id.value = v.id;
      el.id.dispatchEvent(new Event('input', { bubbles: true }));
      el.id.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // add-on
    if (el.addon) {
      el.addon.classList.toggle('is-on', s.addonOn);
      el.addonToggle.setAttribute('aria-checked', s.addonOn ? 'true' : 'false');
      if (el.addonPrice) el.addonPrice.textContent = this.money(s.addonPrice);
    }

    // ATC
    var unit = v ? (alloc ? alloc.price : v.price) : 0;
    var addonQty = cfg.addonQty === 'match' ? s.qty : 1;
    var total = unit * s.qty + (s.addonOn && s.addonId ? s.addonPrice * addonQty : 0);
    if (el.atc) {
      var can = !!(v && v.available);
      el.atc.disabled = !can;
      var txt;
      if (!v) txt = cfg.unavailableText || 'Unavailable';
      else if (!v.available) txt = (v._blocked && v._rule && v._rule.b) ? v._rule.b : (cfg.soldText || 'Sold Out');
      else if (cfg.classic) txt = (cfg.atcText || 'Add to Bag') + (cfg.showPrice ? ' — ' + this.money(total) : '');
      else txt = (cfg.showPrice ? this.money(total) + ' <i class="upd-atc__sep">|</i> ' : '') + (cfg.atcText || 'Add To Cart');
      el.atcLabel.innerHTML = txt;
    }
    var totalEl = this.root.querySelector('[data-total]');
    if (totalEl) totalEl.textContent = this.money(total);

    if (this._sealBoxes) this.restyleSeal();

    // low stock
    if (el.stock) {
      var left = v ? this.inv[String(v.id)] : null;
      var show = v && v.available && left != null && left > 0 && left <= (cfg.lowStock || 0);
      el.stock.hidden = !show;
      if (show) el.stock.textContent = (cfg.lowStockText || 'Only [count] left').replace('[count]', left);
    }

    if (variantChanged && v) {
      if (cfg.updateUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      if (v.featured_media) this.goToMedia(v.featured_media.id);
      this.root.dispatchEvent(new CustomEvent('universal-pdp:variant-change', { bubbles: true, detail: { variant: v } }));
    }
  };

  /* ---------------- Add to cart ---------------- */
  /* Selling plan to send: Seal's own field first, otherwise the plan behind
     the Seal option that is selected (so the subscription is never lost). */
  PDP.prototype.currentPlanId = function () {
    var id = this.sealPlanId();
    var v = this.state.variant;
    if (id) return id;
    var active = this.root.querySelector('.upd-sealopt.is-active.upd-sealopt--sub');
    if (!active || !v) return '';
    var label = active.querySelector('.upd-seallabel');
    var plans = this.sealOptionPlans(active, label ? label.textContent : '') || [];
    var allocs = (v.selling_plan_allocations || []).map(function (a) { return String(a.selling_plan_id); });
    for (var k = 0; k < plans.length; k++) if (allocs.indexOf(plans[k]) > -1) return plans[k];
    return allocs.length === 1 ? allocs[0] : '';
  };

  PDP.prototype.post = function (base, items, extra) {
    var body = Object.assign({ items: items }, extra || {});
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not add to cart.');
        return d;
      });
    });
  };

  PDP.prototype.add = function () {
    var self = this, s = this.state, cfg = this.cfg, v = s.variant;
    if (this._busy) return;                       // ignore double clicks / double events
    if (!v || !v.available) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var qty = Math.max(1, parseInt(this.el.qty ? this.el.qty.value : s.qty, 10) || 1);
    var plan = this.currentPlanId();
    var addonItem = (s.addonOn && s.addonId)
      ? { id: Number(s.addonId), quantity: cfg.addonQty === 'match' ? qty : 1 } : null;

    this._busy = true;
    this.setLoading(true);
    this.showMsg('', false);

    // ---- Standard form submit (Seal handles everything natively) ----
    if (cfg.submitMode === 'native') {
      if (this.el.id) this.el.id.value = v.id;
      var go = function () { self._nativeSubmit = true; self.form.submit(); };
      if (addonItem) this.post(base, [addonItem]).catch(function () {}).then(go);
      else go();
      return;
    }

    // ---- AJAX: product first, add-on second (never one request, so a failed
    //      add-on can't cause a retry that doubles the product) ----
    var main = { id: v.id, quantity: qty };
    if (plan) main.selling_plan = Number(plan);
    var props = {};
    new FormData(this.form).forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && typeof val === 'string' && val !== '') props[m[1]] = val;
    });
    if (Object.keys(props).length) main.properties = props;

    var drawer = document.querySelector('cart-drawer');
    var extra = {};
    if (cfg.afterAdd === 'drawer' && drawer && typeof drawer.getSectionsToRender === 'function') {
      extra.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
      extra.sections_url = window.location.pathname;
    }

    var addonError = null, result = null;
    this.post(base, [main], addonItem ? {} : extra)
      .then(function (d) {
        result = d;
        if (!addonItem) return d;
        return self.post(base, [addonItem], extra)
          .then(function (d2) { result = d2.sections ? Object.assign({}, d, { sections: d2.sections }) : d; })
          .catch(function (err) { addonError = err.message; });
      })
      .then(function () {
        self.afterAdd(result || {}, drawer, base);
        if (addonError) self.showMsg('Added — the add-on could not be added: ' + addonError, true);
      })
      .catch(function (err) { self.showMsg(err.message, true); })
      .then(function () { self._busy = false; self.setLoading(false); });
  };

  PDP.prototype.afterAdd = function (data, drawer, base) {
    var cfg = this.cfg;
    if (cfg.afterAdd === 'cart') { window.location.href = base + 'cart'; return; }

    var detail = { items: data.items || [], source: 'universal-pdp' };
    ['cart:refresh', 'cart:updated', 'cart:build', 'product:added'].concat(cfg.customEvent ? [cfg.customEvent] : [])
      .forEach(function (name) { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); });

    fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cfg.cartCountSelector) return;
      document.querySelectorAll(cfg.cartCountSelector).forEach(function (n) { n.textContent = cart.item_count; });
    }).catch(function () {});

    // Rebuy Smart Cart: refresh its cart (shows the subscription line) and open it
    var R = window.Rebuy;
    if (R && (R.SmartCart || R.Cart)) {
      try {
        var p = R.Cart && typeof R.Cart.fetchCart === 'function' ? R.Cart.fetchCart() : null;
        var open = function () {
          if (cfg.afterAdd === 'drawer' && R.SmartCart && typeof R.SmartCart.show === 'function') R.SmartCart.show();
        };
        if (p && typeof p.then === 'function') p.then(open, open); else setTimeout(open, 250);
        if (cfg.afterAdd === 'drawer') return;
      } catch (err) {}
    }

    if (cfg.afterAdd === 'drawer') {
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(Object.assign({ id: this.state.variant.id }, data));
        return;
      }
      if (cfg.drawerTrigger) {
        var trigger = document.querySelector(cfg.drawerTrigger);
        if (trigger) trigger.click();
        this.showMsg(cfg.addedText, false);
        return;
      }
    }
    this.showMsg(cfg.addedText, false);
  };

  PDP.prototype.setLoading = function (on) {
    if (!this.el.atc) return;
    this.el.atc.classList.toggle('is-loading', on);
    this.el.atc.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) this.el.atc.disabled = true;
    else this.el.atc.disabled = !(this.state.variant && this.state.variant.available);
  };

  PDP.prototype.showMsg = function (text, isError) {
    var m = this.el.msg;
    if (!m) return;
    m.hidden = !text;
    m.textContent = text || '';
    m.classList.toggle('is-error', !!isError);
  };

  /* ---------------- Gallery ---------------- */
  PDP.prototype.bindGallery = function () {
    var self = this, root = this.root;
    this.stage = root.querySelector('[data-stage]');
    if (!this.stage) return;
    this.slides = Array.prototype.slice.call(this.stage.querySelectorAll('.upd-slide'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.upd-dot'));
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    this.index = Number(this.stage.getAttribute('data-start')) || 0;

    var ticking = false;
    this.stage.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; self.syncIndex(); });
    }, { passive: true });

    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(Number(t.getAttribute('data-thumb'))); });
    });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(Math.max(0, self.index - 1)); });
    if (next) next.addEventListener('click', function () { self.goTo(Math.min(self.slides.length - 1, self.index + 1)); });

    // Mouse drag on desktop (touch already swipes natively)
    dragScroll(this.stage, function () { self.syncIndex(); self.goTo(self.index); });
    var thumbsBox = root.querySelector('[data-thumbs]');
    if (thumbsBox) dragScroll(thumbsBox);
  };

  /* Drag-to-scroll with the mouse. A click without movement still works;
     a real drag never triggers the click underneath. */
  function dragScroll(el, onEnd) {
    if (!el || !window.PointerEvent) return;
    var down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (el.scrollWidth <= el.clientWidth + 1) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
      if (moved) { el.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    function end() {
      if (!down) return;
      down = false;
      if (!moved) return;
      setTimeout(function () {
        el.classList.remove('is-dragging');
        if (onEnd) onEnd();
      }, 0);
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  PDP.prototype.syncIndex = function () {
    var left = this.stage.scrollLeft, best = 0, dist = Infinity;
    this.slides.forEach(function (s, i) {
      var d = Math.abs(s.offsetLeft - left);
      if (d < dist) { dist = d; best = i; }
    });
    this.setActive(best);
  };

  PDP.prototype.setActive = function (i) {
    this.index = i;
    this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    this.thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    var at = this.thumbs[i];
    if (at && at.parentNode.scrollWidth > at.parentNode.clientWidth) {
      at.parentNode.scrollTo({ left: at.offsetLeft - 20, behavior: 'smooth' });
    }
  };

  PDP.prototype.goTo = function (i, instant) {
    var s = this.slides && this.slides[i];
    if (!s) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.stage.scrollTo({ left: s.offsetLeft, behavior: (instant || reduce) ? 'auto' : 'smooth' });
    this.setActive(i);
  };

  PDP.prototype.goToMedia = function (mediaId, instant) {
    if (!this.slides) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) { this.goTo(i, instant); return; }
    }
  };

  /* ---------------- Accordion / promo / reviews ---------------- */
  PDP.prototype.bindAccordion = function () {
    this.root.querySelectorAll('[data-acc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.classList.toggle('is-open', open);
        if (panel) panel.classList.toggle('is-open', open);
      });
    });
  };

  PDP.prototype.bindPromo = function () {
    var promo = this.root.querySelector('[data-promo-copy]');
    if (!promo) return;
    var flag = promo.querySelector('[data-promo-copied]'), timer;
    function done() {
      if (!flag) return;
      flag.hidden = false;
      clearTimeout(timer);
      timer = setTimeout(function () { flag.hidden = true; }, 1800);
    }
    function copy() {
      var code = promo.getAttribute('data-promo-copy');
      if (!code) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
        return;
      }
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
    promo.addEventListener('click', copy);
    promo.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copy(); }
    });
  };

  PDP.prototype.bindReviews = function () {
    var track = this.root.querySelector('[data-rev-track]');
    if (!track) return;
    function step(dir) {
      var card = track.querySelector('.upd-revcard');
      var w = card ? card.getBoundingClientRect().width + 14 : 300;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    var p = this.root.querySelector('[data-rev-prev]'), n = this.root.querySelector('[data-rev-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  };

  /* ---------------- Init ---------------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-upd-root]').forEach(function (r) { new PDP(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.UniversalPDP = PDP;
})();
